export default {
    s: { x: 16, y: 120, fontSize: '16px' },
    m: { x: 163, y: 229, fontSize: '24px' },
    l: { x: 601, y: 184, fontSize: '24px' },
    xl: { x: 736, y: 222, fontSize: '32px' },
};
